import {Stack, styled, Typography} from '@mui/material';
import {StyledCard} from 'presentation/components';

const StyledRequestInfoDetailCard = styled(StyledCard.Container)`
	padding: 16px 16px 24px;
`;

const StyledContainerDetail = styled(Stack)`
	gap: 4px;
`;

const StyledProtocolNumberDetail = styled(Typography)`
	font-weight: 400;
	color: ${({theme}) => theme.palette.primary.main};
`;

const StyledProtocolNumber = styled(Typography)`
	font-weight: 600;
`;

const StyledProtocolDateContainer = styled(Stack)`
	justify-content: space-between;
	align-items: center;
	flex-direction: row;
	gap: 8px;
`;

const StyledProtocolDate = styled(Stack)`
	flex-direction: row;
	gap: 8px;
	align-items: center;
`;

export {
	StyledRequestInfoDetailCard,
	StyledContainerDetail,
	StyledProtocolNumberDetail,
	StyledProtocolNumber,
	StyledProtocolDateContainer,
	StyledProtocolDate,
};
